export default __webpack_public_path__ + "static/media/first_step.c1c1d450.svg";